import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import { actions as topikActions } from "../../../../modules/topik";
import { draftKey } from "../useDraft";
import SingleTextAnalysisStep from "./SingleTextAnalysisStep";

// Continue-branch step (§6.2a b): dynamic prompt splices the player's own prior risk text,
// in full - the answer is capped at MAX_TEXT_LENGTH server-side, and players need to see
// exactly what they wrote to reflect on it.
const TopikRiskMitigationView = ({ t, session, topikStatus, gameClosed, dispatch }) => (
  <SingleTextAnalysisStep
    t={t}
    title={t("topik-risk-mitigation-view.title")}
    instruction={t("topik-risk-mitigation-view.instruction", { risk: session.risk })}
    placeholder={t("topik-risk-mitigation-view.placeholder")}
    submitLabel={t("topik-risk-mitigation-view.submit")}
    initialValue={session.riskMitigation || ""}
    draftKey={draftKey(session, "risk_mitigation")}
    maxLength={session.maxTextLength}
    submitting={topikStatus.submitting}
    gameClosed={gameClosed}
    error={topikStatus.error}
    assistStep="riskMitigation"
    onBack={() => dispatch(topikActions.analysis.back.request())}
    onSubmit={(riskMitigation) => (
      dispatch(topikActions.analysis.riskMitigation.request({ riskMitigation }))
    )}
  />
);

TopikRiskMitigationView.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  topikStatus: PropTypes.object.isRequired,
  gameClosed: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

TopikRiskMitigationView.defaultProps = {
  gameClosed: false,
};

const mapStateToProps = (state) => ({
  session: state.topik.session,
  topikStatus: state.topik.status,
});

export default compose(withTranslation("views"), connect(mapStateToProps))(TopikRiskMitigationView);
